// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"3131efcd","223":"eee49fcd"}[chunkId] + ".chunk.js";
};